import axios from "axios";
import config from "../../config";

const BASE_URL = `${config.url}/api/book_package_plans`;

const PackagePlanManager = {
  // Get all plans
  async getAllBookPackagePlans() {
    const response = await axios.get(BASE_URL);
    return response.data.responseData;
  },


async getActiveBookPackagePlans() {
  const response = await axios.get(`${BASE_URL}`);
 return response.data.responseData;
},

  // Get single plan by ID
  async getBookPackagePlanById(id) {
    const response = await axios.get(`${BASE_URL}/${id}`);
    return response.data;
  },

  // Create a new plan (with embedded packages)
  async addBookPackagePlan(planDto) {
    const response = await axios.post(BASE_URL, planDto, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  },

  // Update existing plan
  async updateBookPackagePlan(id, planDto) {
    const response = await axios.put(`${BASE_URL}/${id}`, planDto, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  },

  // Delete a plan by ID
  async deleteBookPackagePlan(id) {
    const response = await axios.delete(`${BASE_URL}/${id}`);
    return response.data;
  },
};

export default PackagePlanManager;
